import styled from "@emotion/styled/macro";
import { Outlet, useLocation } from "react-router-dom";
import BigScreenWebPage from "../../../unreal/BigScreenWebPage";
import { BigScreenLogin } from "../../../unreal/pages/pageDescriptors";
import {ContentDiv, ThemeCss, VscTheme} from "../../content/ContentComponent";
import {ThemeColors} from "../../layout/GlobalLayout";
import {VscUrlSource} from "../../content/ContentRendererJSX";
import {useConfig} from "../../../config";
import {useCommunityContext} from "../../../context/communityContext";
import {PropsWithChildren} from "react";
import {useQueryState} from "use-location-state";
import {useVscContext} from "../../content/VscReactContext";

const BannerDiv = styled.div`
  margin-top: 20px;
  margin-left: 20px;
  position: absolute;
`
const LoginDiv = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    > * {
      flex-grow: 1;
      flex-basis: 100%;
    }
`
const LoginDivImage = styled.div`
    img {
      height: 70%;
      border-radius: 0px 375px 375px 0px;
    }
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
`
const LoginFormLayout = styled.div`
    box-sizing: border-box;
    display:flex;
    flex-direction: column;
  height:100%;
    align-items: center;
    justify-content: center;
    padding: 74px;
`



const Subtitle = styled.h3`
    color: #4D4D4D;
    font-size: 1.125rem;
    font-weight: 400;
    margin-bottom: 15px;
    text-align: center;
`

const LogIn: React.FC<PropsWithChildren<{theme:string}>> = (props) => {
    const { pathname } = useLocation();
    const { theme } = props;

    const [login, setLogin] = useQueryState("login", "");

    const { server, contentServer } = useConfig();
    const { community } = useCommunityContext();
    const vscContext = useVscContext();

    let title = "";
    let subTitle ="";
        title = 'Welcome';
        subTitle = 'Enter phone number to get started:';
    if(login === "account-found"){
        title = 'Account Found';
        subTitle = 'Please check that your information is correct';
    }
    if(login === "create-account"){
        title = 'Create An Account';
        subTitle = 'Please enter your information below to get started';
    }

    return <>

       <LoginDiv>

        <LoginDivImage>
            <img alt="" src={vscContext.getHtmlContentUri("login.jpg?shared=themes/" + encodeURIComponent(theme))}/>
        </LoginDivImage>
           <ContentDiv>

           <LoginFormLayout>
            <h1>
                {title}
            </h1>
            <Subtitle>
                {subTitle}
            </Subtitle>
               { props.children}
        </LoginFormLayout>
           </ContentDiv>
    </LoginDiv>
    </>

}
export default LogIn;
